/* src/app/components/modal-chapter-updated/modal-chapter-updated.component.scss */
.section-img {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=modal-chapter-updated.component.css.map */
